import pink from '@material-ui/core/colors/pink';
import lightGreen from '@material-ui/core/colors/lightGreen';
import dark from '@material-ui/core/colors/blueGrey';

const styles = theme => ({
  divider: {
    margin: `${theme.spacing.unit * 3}px 0`
  },
  card: {
    minWidth: 275,
  },
  liked: {
    color: pink[500]
  },
  shared: {
    color: lightGreen[500]
  },
  num: {
    fontSize: 14,
    marginLeft: 5
  },
  rightIcon: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    marginRight: theme.spacing.unit
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  mediaCartoon: {
    position: 'relative',
    height: 200,
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& div':{
      height: '100%',
    },
    '& img':{
      position: 'absolute',
      //top: '-25%',
      width: '100%'
    }
  },
  // Para slider lo Relevante
  cardMedia:{
    position: 'relative',
    maxHeight: '330px !important'
  },
  mediaRelevante: {
    position: 'relative',
    // height: 370,
    overflow: 'hidden',
    '& div':{
      height: '100%',
    },
    '& div':{
      height: '100%',
      backgroundColor: 'black',
    },
    '& img':{
      opacity: .7,
      //top: '-25%',
      width: '100%'
    }
  },
  contentRelevante: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    marginBottom: 0,
    paddingBottom: '15px !important',
    '& p':{
      color: 'white  !important'
    }
  },
  cardPlayer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 150,
    height: 150,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  cardSocmed: {
    minWidth: 275,
  },
  cardProduct: {
    position: 'relative'
  },
  mediaProduct: {
    height: 0,
    paddingTop: '60.25%', // 16:9
  },
  rightAction: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    '& small': {
      fontSize: 12
    }
  },
  floatingButtonWrap: {
    position: 'relative',
    paddingTop: 50
  },
  buttonAdd: {
    position: 'absolute',
    right: 20,
    top: -20,
  },
  buttonAddList: {
    display: 'none',
    marginLeft: 10
  },
  title: {
    fontSize: 20,
    height: 30,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.primary.main
  },
  ratting: {
    margin: '10px 0',
    '& button': {
      width: 24,
      height: 24
    }
  },
  status: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 10,
    '& > *': {
      margin: 5
    }
  },
  desc: {
    height: 45,
    overflow: 'hidden'
  },
  chipDiscount: {
    background: theme.palette.primary.light,
    color: theme.palette.primary.dark,
  },
  chipSold: {
    background: dark[500],
    color: theme.palette.getContrastText(dark[500]),
  },
  contentProfle: {
    flex: '1 0 auto',
    textAlign: 'center'
  },
  mediaProfile: {
    height: 0,
    paddingTop: '36.25%', // 16:9
  },
  actions: {
    display: 'flex',
    backgroundColor: 'transparent !important'
  },
  avatarBig: {
    width: 80,
    height: 80,
    margin: '-56px auto 10px',
    background: theme.palette.secondary.dark
  },
  name: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonProfile: {
    margin: 20
  },
  bottomLink: {
    width: '100%',
  },
  price: {
    paddingBottom: 20
  },
  contentProfile: {
    textAlign: 'center'
  },
  verified: {
    fontSize: 16,
    color: theme.palette.primary.main
  },
  cardList: {
    display: 'flex',
    justifyContent: 'space-between',
    '& $buttonAddList': {
      display: 'inline-block'
    },
    '& $floatingButtonWrap': {
      flex: 1,
    },
    '& $buttonAdd': {
      display: 'none'
    },
    '& $status': {
      right: 'auto',
      left: 0,
    },
    '& $mediaProduct': {
      width: 300,
      paddingTop: '21.25%'
    },
    '& $price': {
      flexDirection: 'column',
      justifyContent: 'center',
      '& button': {
        marginTop: 20
      }
    }
  },
  televisaContent: {
    textAlign: 'left',
    paddingBottom: 0,
    '& > p':{
      marginBottom: 0
    }
  },
  textLeft: {
    textAlign: 'left',
  },
  color1: {
    backgroundColor: theme.palette.primary.main
  },
  color2: {
    backgroundColor: theme.palette.secondary.main
  },
  color3: {
    backgroundColor: '#006687'
  },
  btnContrast:{
    color: "#cacaca"
  },
  btnActive: {
    color: theme.palette.primary.contrastText
  }
});

export default styles;
